const OPTIONS = {
    BR: {
        SP: 480,
        PC: 780,
    },
    PRM: {
        SCROLLY: 0,
        SCREENY: 0,
        SCREENX: 0,
    },
    EL: {
        HEADER: null
    }
};
const headerMenuDrops = [...document.querySelectorAll(".header_menu_drop")]
const setAccordionPost = () => {
    headerMenuDrops.map((headerMenuDrop) => {
        headerMenuDrop.parentNode.querySelector(".header_menu_item_inner").addEventListener("click", () => {
            accordionHandler(headerMenuDrop, "open")
        })
        headerMenuDrop.parentNode.addEventListener("mouseenter", () => {
            accordionHandler(headerMenuDrop, "open")
        })
        headerMenuDrop.parentNode.addEventListener("mouseleave", () => {
            accordionHandler(headerMenuDrop, "close")
        })
    })
}
const accordionHandler = (headerMenuDrop, action) => {
        const removeTrg = [...document.querySelectorAll(".show")]
        if (action === "close" && removeTrg) {
            return removeTrg.map(removeElement => removeElement.classList.remove("show"))
        } else if (action === "open") {
            if (removeTrg) {
                removeTrg.map(removeElement => removeElement.classList.remove("show"))
            }
            headerMenuDrop.parentElement.classList.add("show")
        }
    }
    // const headerMenuDrops = [...document.querySelectorAll(".header_menu_drop")]
    // const headerHeights = []
    // headerMenuDrops.map(headerMenuDrop => {
    //     headerMenuDrop.style.opacity = 0
    //     headerMenuDrop.style.display = "block"
    //     // const { height } = headerMenuDrop.getBoundingClientRect()
    //     const { bottom } = headerMenuDrop.parentNode.getBoundingClientRect()
    //     headerHeights.push(bottom)
    //     headerMenuDrop.style.display = "none"
    // })
    // const setAccordionPost = () => {
    //     headerMenuDrops.map((headerMenuDrop, i) => {
    //         headerMenuDrop.style.top = headerHeights[i] + "px"
    //         const { left } = headerMenuDrop.parentElement.getBoundingClientRect()
    //         headerMenuDrop.style.left = left + "px"
    //         headerMenuDrop.parentNode.querySelector(".header_menu_item_inner").addEventListener("click", () => {
    //             accordionHandler("open", headerMenuDrop, i)
    //         })
    //         headerMenuDrop.parentNode.addEventListener("mouseenter", () => {
    //             accordionHandler("open", headerMenuDrop, i)
    //         })
    //         headerMenuDrop.parentNode.addEventListener("mouseleave", () => {
    //             accordionHandler("close", headerMenuDrop, i)
    //         })
    //     })
    // }
    // const accordionHandler = (action, headerMenuDrop, i) => {
    //     console.log(headerMenuDrop)
    //     if (action === "open" || !headerMenuDrop.parentElement.classList.contains("show")) {
    //         headerMenuDrop.style.top = document.getElementById("header").getBoundingClientRect().height + "px"
    //             // if (document.querySelector(".show")) {
    //             //     const removeElement = document.querySelector(".show")
    //             //     const isItself = headerMenuDrop.parentElement.classList.contains("show")
    //             //     if (removeElement.querySelector(".header_menu_drop")) {
    //         //         removeElement.querySelector(".header_menu_drop").style.opacity = 0
    //         //         removeElement.querySelector(".header_menu_drop").style.display = "none"
    //         //         removeElement.querySelector(".header_menu_drop").animate(
    //         //             [
    //         //                 // キーフレーム
    //         //                 {
    //         //                     height: headerHeights[i] + "px",
    //         //                     display: "block",
    //         //                     opacity: 1,
    //         //                     overflow: "hidden"
    //         //                 },
    //         //                 {
    //         //                     height: "0px",
    //         //                     opacity: 1,
    //         //                     overflow: "hidden"
    //         //                 },
    //         //             ], {
    //         //                 // タイミングオプション
    //         //                 duration: 150,
    //         //             }, )
    //         //         removeElement.classList.remove("show")
    //         //     }
    //         //     if (isItself) return
    //         // }
    //         headerMenuDrop.parentElement.classList.add("show")
    //         headerMenuDrop.style.opacity = 1
    //         headerMenuDrop.style.display = "block"
    //         headerMenuDrop.animate(
    //             [
    //                 // キーフレーム
    //                 {
    //                     height: "0px",
    //                     overflow: "hidden"
    //                 },
    //                 {
    //                     height: headerHeights[i] + "px",
    //                     overflow: "hidden"
    //                 },
    //             ], {
    //                 // タイミングオプション
    //                 duration: 150,
    //             }, )
    //     } else if (action === "close") {
    //         if (document.querySelector(".show")) {
    //             const removeElement = document.querySelector(".show")
    //             if (removeElement.querySelector(".header_menu_drop")) {
    //                 removeElement.querySelector(".header_menu_drop").style.opacity = 0
    //                 removeElement.querySelector(".header_menu_drop").style.display = "none"
    //                 removeElement.querySelector(".header_menu_drop").animate(
    //                     [
    //                         // キーフレーム
    //                         {
    //                             height: headerHeights[i] + "px",
    //                             display: "block",
    //                             opacity: 1,
    //                             overflow: "hidden"
    //                         },
    //                         {
    //                             height: "0px",
    //                             opacity: 1,
    //                             overflow: "hidden"
    //                         },
    //                     ], {
    //                         // タイミングオプション
    //                         duration: 150,
    //                     }, )
    //                 removeElement.classList.remove("show")
    //             }
    //         }
    //     }
    // }
const toggleClass = (event, className, idName, trgsClass) => {
    event.preventDefault();
    const trg = document.getElementById(idName) || event.currentTarget.parentNode;

    if (trgsClass) {
        const trgsArr = [...document.querySelectorAll(`.${trgsClass}`)]
        trgsArr.map(el => el.classList.contains(className) ? el.classList.remove(className) : null)
        trg.classList.add(className);
        window.scrollTo({
            top: trg.getBoundingClientRect().top + window.pageYOffset - OPTIONS.EL.HEADER.clientHeight,
            behavior: 'smooth'
        })
    } else {
        trg.classList.contains(className) ?
            trg.classList.remove(className) :
            trg.classList.add(className);
        ///IDがヘッダならscroll禁止
        if (idName === "header") {
            const menuInner = document.querySelector(".hum .header_menu_list")
            console.log(menuInner);
            if (!trg.classList.contains(className)) {
                document.body.style.height = 'auto'
                document.body.style.overflow = 'visible'
                window.scrollTo({ top: OPTIONS.PRM.SCROLLY })
            } else {
                document.body.style.height = `${window.innerHeight}px`
                document.body.style.overflow = 'hidden'
                menuInner.style.top = `${OPTIONS.EL.HEADER.clientHeight < window.scrollY?OPTIONS.EL.HEADER.clientHeight:OPTIONS.EL.HEADER.clientHeight-window.scrollY}px`
                menuInner.style.height = `${window.innerHeight - OPTIONS.EL.HEADER.clientHeight}px`
            }
        }
    }
};

///stick header 処理
const HEADER = document.getElementById("header") || null;
OPTIONS.EL.HEADER = HEADER
const scrollEventHandler = (event) => {
    OPTIONS.PRM.SCROLLY = window.scrollY;
    if (HEADER === null) return;
    const HEAD_HEIGHT = HEADER.clientHeight;
    if (OPTIONS.PRM.SCROLLY > HEAD_HEIGHT) {
        HEADER.classList.add("following");
        HEADER.style.paddingTop = `${HEAD_HEIGHT}px`;
    } else {
        HEADER.classList.remove("following");
        HEADER.style.paddingTop = 0;
    }
};
window.addEventListener("scroll", scrollEventHandler);

const resizeEventHandler = () => {
    setAccordionPost()
    switchImages(OPTIONS.BR.SP);
    switchImages(OPTIONS.BR.PC);
    if (window.innerWidth < OPTIONS.BR.PC) {
        OPTIONS.EL.HEADER.classList.add("hum")
    } else {
        OPTIONS.EL.HEADER.classList.remove("hum")
        OPTIONS.EL.HEADER.querySelector('.header_menu_list').style.height = 'auto'
    }
}
const switchImages = (prm) => {
    const domName = () => {
        switch (prm) {
            case OPTIONS.BR.PC:
                {
                    return ".switcher img";
                }
            case OPTIONS.BR.SP:
                {
                    return ".switcher_sp img";
                }
        }
    };
    const className = domName();
    //switcherクラス内の画像を取得
    const elem = document.querySelectorAll(className);
    //画面の横幅を取得
    const screen_w = window.innerWidth;
    // console.log(screen_w);

    //画像名書き換え関数（書き換え対象、書き換え内容）
    function remane(source, result) {
        for (var i = 0; i < elem.length; i++) {
            const src = elem[i].getAttribute("src");
            elem[i].setAttribute("src", src.replace(source, result));
        }
    }
    if (screen_w > prm) {
        //横幅760以上の場合は"_sp"を"_pc"に変換
        remane("_sp.", "_pc.");
    } else {
        //横幅760以上の場合は"_pc"を"_sp"に変換
        remane("_pc.", "_sp.");
    }
};
resizeEventHandler();
window.onresize = resizeEventHandler;


const init = () => {
    ////初回処理
    const allAnkers = [...document.querySelectorAll(".anker_gap")] || null
    if (allAnkers !== null) {
        allAnkers.forEach((anker) => {
            anker.style.paddingTop = `${OPTIONS.EL.HEADER.clientHeight}px`
            anker.style.marginTop = `-${OPTIONS.EL.HEADER.clientHeight}px`
        })
    }
}
window.onload = init


/**
 * tab選択処理
 * prms = {
 * id: id名
 * }
 * */
const tabSelect = (event, prms) => {
    event.preventDefault()
    event.stopPropagation();
    console.log(event.currentTarget.classList.contains('selected'));
    if (event.currentTarget.classList.contains('selected')) return
    removeSelected()
    const { id } = prms
    const trg = document.getElementById(id)
    trg.classList.add('selected')
    event.currentTarget.classList.add('selected')
}
const removeSelected = () => {
    const trg = document.querySelector('.tab.selected')
    const tab_sector = document.querySelector('.tab_sector.selected')
    trg.classList.remove('selected')
    tab_sector.classList.remove('selected')
}

const toggleShow = (event) => {
    event.preventDefault()
    const trg = event.currentTarget.parentNode
    trg.classList.contains('show') ? trg.classList.remove('show') : trg.classList.add('show')
}

/**画面固定
 * command → boolean 
 * true 固定
 * false 解除
 */
const fixScreen = (command) => {
    if (command) {
        document.body.style.height = `${window.innerHeight}px`
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.height = 'auto'
        document.body.style.overflow = 'visible'
        window.scrollTo({ top: OPTIONS.PRM.SCROLLY })
    }
}